import React, { useContext, useEffect, useState } from 'react'
import { jwtDecode } from "jwt-decode"
import { NormasContext } from '../../context/NormasContext'
import "./EditarNorma.scss"
import EditarSubtarea from './EditarSubtarea'
import ModalEditarNorma from '../../components/Modales/Normas/ModalEditarNorma'
// React Bootstrap
import { Oval } from 'react-loader-spinner';
import Accordion from 'react-bootstrap/Accordion';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';

export const editarNormaContext = React.createContext()

function EditarNorma() {

    const auth = localStorage.getItem("token")
    const jwtParse = jwtDecode(JSON.parse(auth))
    const user = jwtParse.apirest.objeto

    const { 
        status, 
        templates, 
        fetchTemplates,
        tareas,
        fetchTareas,
        subtareas,
        fetchSubtareas
    } = useContext(NormasContext)

    const [idProyectoNorma, setIdProyectoNorma] = useState(null)
    const [idNorma, setIdNorma] = useState(null)

    const [tituloNorma, setTituloNorma] = useState(null)
    const [descNorma, setDescNorma] = useState(null)

    const [activeTaskKey, setActiveTaskKey] = useState(null); 

    const [modalEditar, setModalEditar] = useState(false)
    const [opc, setOpc] = useState(null)
    const [objEditar, setObjEditar] = useState(null)

    const [objTareaSub, setObjTareaSub] = useState(null)

    useEffect(() => {
        fetchTemplates({user})
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(() => {
        if (!status.templates.loading && templates?.objeto?.length > 0) {
            const firstTemplate = templates.objeto[0]
            showTareas(firstTemplate.id_proyecto_norma)
            setIdProyectoNorma(parseInt(firstTemplate.id_proyecto_norma))
            setIdNorma(parseInt(firstTemplate.fk_norma))
            // mostrar detalles
            setTituloNorma(firstTemplate.nombre)
            setDescNorma(firstTemplate.detalles)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status.templates.loading, templates]);

    useEffect(() => {
        if (!activeTaskKey) return;

        if (!subtareas?.[activeTaskKey]) {
            fetchSubtareas({ idtarea: activeTaskKey });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTaskKey]);

    const title = (
        <>
            <div className='section__header d-flex flex-row align-items-end mb-4'>
                <i className='bi bi-patch-check me-2'></i>
                <h4 className='m-0'>Normas ISO</h4>
            </div>
        </>
    )

    const handleTaskSelect = (eventKey) => {
        setActiveTaskKey(activeTaskKey === eventKey ? null : eventKey);
    };

    const showTareas = async (id) => {
        const obj = templates?.objeto.find((e) => e.id_proyecto_norma === parseInt(id))
        setTituloNorma(obj.nombre)
        setDescNorma(obj.detalles)
        await fetchTareas({
            idProyecto: id
        })
    }

    const handleEdit = (id, opcion) => {
        setOpc(opcion)
        if(opcion === 1) {
            const objNorma = templates?.objeto.find((e) => e.id_proyecto_norma === parseInt(id))
            setObjEditar(JSON.stringify(objNorma))
        } else if (opcion === 2) {
            const objTarea = tareas.find((e) => e.id_tarea_norma === parseInt(id))
            setObjEditar(JSON.stringify(objTarea))
        } else if (opcion === 3) {
            // obj tarea
            const objTareaSub = tareas.find((e) => e.id_tarea_norma === parseInt(activeTaskKey))
            setObjTareaSub(JSON.stringify(objTareaSub))
            // obj subtarea
            const listaSubtareas = subtareas?.[activeTaskKey] || []
            const objSubtarea = listaSubtareas.find((e) => e.id_subtarea_norma === parseInt(id))
            setObjEditar(JSON.stringify(objSubtarea))
        }
        setModalEditar(true)
    }

    return (
        <>
            <editarNormaContext.Provider value={{ opc, idProyectoNorma, idNorma, user, objEditar, setObjEditar, objTareaSub, setObjTareaSub, fetchTemplates, fetchSubtareas, fetchTareas }}>
                <ModalEditarNorma show={modalEditar} onHide={()=>setModalEditar(false)} animation={false} dialogClassName="custom-fade-modal" />
                <div className='editarNorma'>
                    {title}
                    <div className='editarNorma__container'>
                        {status.templates.loading ? (
                            <div className='loading__editarNorma--templates d-flex flex-column align-items-center justify-content-center'>
                                <Oval
                                    visible={true}
                                    height="80"
                                    width="80"
                                    color="#0d6efd"
                                    ariaLabel="oval-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                                <p className='fw-medium'>Loading...</p>
                            </div>
                        ) : (
                            <>
                                {status.templates.error ? (
                                    <div className='editarNorma__container__error'>
                                        <p>{status.templates.error}</p>
                                    </div>
                                ) : (
                                    <div className='editarNorma__container__main'>
                                        <Tab.Container 
                                            defaultActiveKey={0}
                                            onSelect={(key) => {
                                                setIdProyectoNorma(templates?.objeto[key].id_proyecto_norma)
                                                setIdNorma(templates?.objeto[key].fk_norma)
                                                showTareas(templates?.objeto[key].id_proyecto_norma)
                                            }}
                                        >
                                            <Row>
                                                <Col className='editarNorma__container__main__lista scroll--y' sm={3}>
                                                    <Nav variant="pills" className="flex-column">
                                                        {templates?.objeto.map((t, i) => (
                                                            <Nav.Item key={i}>
                                                                <Nav.Link eventKey={i}>{t.nombre}</Nav.Link>
                                                            </Nav.Item>
                                                        ))}
                                                    </Nav>
                                                </Col>
                                                <Col className='editarNorma__container__main__contenido scroll--y' sm={9}>
                                                    <div>
                                                        {/* Titulo de la norma */}
                                                        <div className='d-flex flex-column'>
                                                            <div className='mb-2 d-flex flex-row align-items-center gap-4'>
                                                                <h4 className='m-0 p-0 text-blue-500 fw-medium'>Título de la norma</h4>
                                                                <button 
                                                                    className='btnEditTextosNormas btn btn-sm btn-success rounded-pill px-3 fw-medium cursor-pointer ms-auto d-flex align-items-center justify-content-center'
                                                                    onClick={()=>handleEdit(idProyectoNorma, 1)}
                                                                >Editar norma</button>
                                                            </div>
                                                            {tituloNorma && (
                                                                <div className='texto-descripcion'>
                                                                    <p>{tituloNorma}</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Descripción de la norma */}
                                                        <div className='d-flex flex-column'>
                                                            <h4 className='m-0 p-0 mb-2 text-blue-500 fw-medium'>Descripción de la norma</h4>
                                                            {descNorma && (
                                                                <div className='texto-descripcion'>
                                                                    <p>{descNorma}</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <Tab.Content>
                                                        <h4 className='m-0 p-0 mb-3 text-blue-500 fw-medium'>Secciones de la norma</h4>
                                                        {templates?.objeto.map((t, i) => (
                                                            <Tab.Pane eventKey={i} key={i}>
                                                                {status.tareas?.loading ? (
                                                                    <div className='loading__editarNorma--tareas d-flex flex-column align-items-center justify-content-center'>
                                                                        <Oval
                                                                            visible={true}
                                                                            height="80"
                                                                            width="80"
                                                                            color="#0d6efd"
                                                                            ariaLabel="oval-loading"
                                                                            wrapperStyle={{}}
                                                                            wrapperClass=""
                                                                        />
                                                                        <p className='fw-medium'>Loading...</p>
                                                                    </div>
                                                                ) : status.tareas?.error ? (
                                                                    <p className="text-danger">{status.tareas.error}</p>
                                                                ) : (
                                                                    <Accordion activeKey={activeTaskKey} onSelect={handleTaskSelect}>
                                                                        {tareas.map((tarea, i) => (
                                                                            <Accordion.Item 
                                                                                key={tarea.id_tarea_norma} 
                                                                                eventKey={tarea.id_tarea_norma.toString()}
                                                                            >
                                                                                <Accordion.Header>{tarea.nombre}</Accordion.Header>
                                                                                <Accordion.Body>
                                                                                    {/* Titulo de la tarea */}
                                                                                    <div className='d-flex flex-column'>
                                                                                        <div className='mb-2 d-flex flex-row align-items-center gap-4'>
                                                                                            <h4 className='m-0 p-0 text-blue-500 fw-medium'>Título de la sección</h4>
                                                                                            <button 
                                                                                                className='btnEditTextosNormas btn btn-sm btn-success rounded-pill px-3 fw-medium cursor-pointer ms-auto d-flex align-items-center justify-content-center'
                                                                                                onClick={()=>handleEdit(tarea.id_tarea_norma, 2)}
                                                                                            >Editar sección</button>
                                                                                        </div>
                                                                                        <div className='texto-descripcion'>
                                                                                            <p>{tarea.nombre}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                    {/* Descripción de la tarea */}
                                                                                    {tarea.descripcion && (
                                                                                        <div className='d-flex flex-column'>
                                                                                            <h4 className='m-0 p-0 mb-2 text-blue-500 fw-medium'>Descripción de la sección</h4>
                                                                                            <div className='texto-descripcion'>
                                                                                                <p>{tarea.descripcion}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                    {activeTaskKey === tarea.id_tarea_norma.toString() && (
                                                                                        <EditarSubtarea idTarea={tarea.id_tarea_norma} handleEdit={handleEdit} />
                                                                                    )}
                                                                                </Accordion.Body>
                                                                            </Accordion.Item>
                                                                        ))}
                                                                    </Accordion>
                                                                )}
                                                            </Tab.Pane>
                                                        ))}
                                                    </Tab.Content>
                                                </Col>
                                            </Row>
                                        </Tab.Container>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </editarNormaContext.Provider>
        </>
    )
}

export default EditarNorma